module.exports = __webpack_public_path__ + "videos/animation_worm.mp4";